<template>
  <div class="verify-code-input">
    <input
      v-for="(v, i) in codeArr"
      :key="i"
      ref="inputs"
      type="text"
      maxlength="1"
      pattern="[0-9]*"
      inputmode="numeric"
      :value="v"
      @input="onInput($event, i)"
      @keydown="onKeydown($event, i)"
      @paste="onPaste($event)"
      @focus="$event.target.select()"
      class="code-box"
      autocomplete="one-time-code"
    />
  </div>
</template>

<script>
export default {
  name: 'VerifyCodeInput',
  props: {
    value: {
      type: String,
      default: ''
    },
    length: {
      type: Number,
      default: 6
    }
  },
  data () {
    return {
      codeArr: Array(this.length).fill('')
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (val) {
        this.codeArr = (val || '').split('').concat(Array(this.length).fill('')).slice(0, this.length)
      }
    }
  },
  methods: {
    onInput (e, idx) {
      let val = e.target.value.replace(/[^0-9]/g, '')
      if (val.length > 1) val = val.slice(-1)
      this.$set(this.codeArr, idx, val)
      this.emitValue()
      if (val && idx < this.length - 1) {
        this.$refs.inputs[idx + 1].focus()
      }
    },
    onKeydown (e, idx) {
      if (e.key === 'Backspace' && !this.codeArr[idx] && idx > 0) {
        this.$refs.inputs[idx - 1].focus()
      }
    },
    onPaste (e) {
      const paste = (e.clipboardData || window.clipboardData).getData('text').replace(/[^0-9]/g, '')
      if (paste.length === this.length) {
        for (let i = 0; i < this.length; i++) {
          this.$set(this.codeArr, i, paste[i])
        }
        this.emitValue()
        this.$nextTick(() => {
          this.$refs.inputs[this.length - 1].focus()
        })
        e.preventDefault()
      }
    },
    emitValue () {
      this.$emit('input', this.codeArr.join(''))
    }
  }
}
</script>

<style scoped>
.verify-code-input {
  display: flex;
  gap: 12px;
  justify-content: center;
  margin: 16px 0 24px 0;
}
.code-box {
  width: 48px;
  height: 48px;
  font-size: 28px;
  text-align: center;
  border: 1.5px solid #d9d9d9;
  border-radius: 8px;
  outline: none;
  transition: border-color 0.2s;
  background: #fff;
}
.code-box:focus {
  border-color: #409eff;
  box-shadow: 0 0 0 2px #409eff22;
}
@media (max-width: 768px) {
  .code-box {
    width: 38px;
    height: 38px;
    font-size: 22px;
  }
}
</style>
